<template>
  <div>
    <div class="d-flex align-items-center justify-content-center placeholder">
      <label>
          {{message}}
      </label>
    </div>
    <div class="d-flex align-items-center justify-content-center placeholder">
      <font-awesome-icon icon="spinner" :size="size" pulse />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      default: '2x',
    },
    message: {
      default: 'Loading',
    },
  },
};
</script>
